import { MapPin } from "lucide-react";
import { AnimatedDiv } from "@/components/motion";
import { stats, brands } from "./data";

export const StatsStrip = () => (
  <section className="bg-[#0F172A] py-12" data-testid="presence-stats">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
        {stats.map((s) => (
          <div key={s.label} className="text-center md:text-left md:border-l md:border-white/10 md:pl-6 first:border-0 first:pl-0">
            <p className="font-serif text-3xl md:text-4xl text-[#C5A059]">{s.value}</p>
            <p className="text-xs font-sans uppercase tracking-[0.2em] text-white/60 mt-2">{s.label}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

function BrandRow({ brand, index }) {
  return (
    <div
      data-testid={`brand-row-${brand.name.toLowerCase().replace(/\s/g, "-")}`}
      className="grid lg:grid-cols-12 gap-10 items-stretch"
    >
      <div className={`lg:col-span-5 ${index % 2 === 1 ? "lg:order-2" : ""}`}>
        <div className="h-full bg-white border border-border flex flex-col items-center justify-center px-10 py-16 relative">
          <span className="absolute top-6 left-6 font-serif text-5xl text-foreground/5 select-none">0{index + 1}</span>
          <img src={brand.logo} alt={`${brand.name} logo`} className="max-h-24 lg:max-h-28 w-auto max-w-[70%] object-contain" />
          <p className="text-xs font-sans uppercase tracking-[0.25em] text-muted-foreground mt-8">{brand.division}</p>
        </div>
      </div>
      <div className={`lg:col-span-7 flex flex-col justify-center ${index % 2 === 1 ? "lg:order-1" : ""}`}>
        <p className="text-xs font-sans uppercase tracking-[0.2em] text-[#C5A059] mb-3">{brand.reach}</p>
        <h3 className="text-3xl md:text-4xl font-serif tracking-tight text-foreground mb-5">{brand.name}</h3>
        <p className="text-base font-sans text-muted-foreground leading-relaxed mb-8 max-w-xl">{brand.description}</p>
        <div className="flex flex-wrap gap-3">
          {brand.markets.map((m) => (
            <span key={m} className="inline-flex items-center gap-2 border border-border bg-white px-4 py-2 text-xs font-sans uppercase tracking-[0.12em] text-foreground">
              <MapPin size={12} className="text-[#C5A059]" /> {m}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}

export const BrandShowcase = () => (
  <section className="py-24 lg:py-32 bg-background">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <AnimatedDiv className="max-w-2xl mb-20">
        <p className="text-xs font-sans uppercase tracking-[0.2em] text-[#C5A059] mb-4">The House of KF</p>
        <h2 className="text-3xl md:text-5xl font-serif tracking-tight text-foreground mb-4">Where Our Brands Live</h2>
        <p className="text-base font-sans text-muted-foreground leading-relaxed">
          Each brand in our portfolio commands its own markets — together, they form a network that spans the subcontinent and reaches into the Gulf.
        </p>
      </AnimatedDiv>
      <div className="space-y-20">
        {brands.map((b, i) => (
          <AnimatedDiv key={b.name}>
            <BrandRow brand={b} index={i} />
          </AnimatedDiv>
        ))}
      </div>
    </div>
  </section>
);
